<template lang="pug">
.content
  ed-tab-nav.uniform(workflow)
    ed-tab(title="Completed Agenda" :completed="true" :icon="['fal', 'list-alt']")
      project-agenda
    ed-tab(title="Project Information" :active="true" :icon="['fal', 'clipboard']")
      project-information
    ed-tab(title="Clients" :completed="true" :icon="['fal', 'address-book']")
      project-clients
    ed-tab(title="Services" :icon="['fal', 'shopping-basket']")
      -project-services
      p
        ed-button.btn.btn-actionbar(@click='create') Create!
    ed-tab(title="Design & Layout" :icon="['fal', 'paint-brush']")
      project-design
    ed-tab(title="Project Settings" :icon="['fal', 'rocket']")
      project-settings
  .container
    .row
      .col-md-12
        ed-button.btn.btn-primary(@click="showModal1 = true") Launch Modal 1
        ed-modal(:show="showModal1" @close="showModal1 = false" title="Budget Information" subtitle="Tell us about your budget.")
          div(slot="body")
            program-list(legacy='true' layout='small')
</template>

<script>

import { Eved, EventBus } from '@/event-bus'
import ProgramList from '@/components/_modules/Programs/Program-list'
import model from '@/components/_modules/Programs/Program-list/model'

export default {
  description: 'Create a new Program',
  components: {
    ProgramList
  },
  data () {
    return {
      name: 'create-program',
      model,
      showModal1: false
    }
  },

  mounted() {
    //
  },

  methods: {
    create: function () {
      console.log(+new Date())
      EventBus.$emit(Eved.RFP.CREATED, 'created something', this)
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/create.vue